<div class="machine-parameter-content" dir="{{languageDir}}">
    <div class="content-top-box">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}
          </a>
        </li>
      </ul>
      <div class="tab-content-top-box">
        <h1 class="main-title">{{langObj ? langObj?.WhatAppConfig : ('WhatAppConfig' | translate)}}</h1>
      </div>
    </div>
    <form [formGroup]="whatAppConfigForm">
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div class="content-top-row">
          <mat-form-field appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="margin-left: 14px">
            <mat-label>{{langObj ? langObj?.Group : ('Group' | translate)}}</mat-label>
            <mat-select panelClass="testClass" formControlName="group" name="Group"
              (selectionChange)="getPlants()">
                <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="groupList"
                  (filteredReturn)="filteredModules = $event">
                </mat-select-filter>
                <mat-option *ngFor="let group of filteredModules" [value]="group.TypeId">
                  {{ group.TypeName }}
                </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="margin-left: 14px">
            <mat-label>{{langObj ? langObj?.Plant : ('Plant' | translate)}}</mat-label>
            <mat-select panelClass="testClass" formControlName="plant" name="Plant"
              (selectionChange)="GetWhatAppConfigList()">
                <mat-select-filter [placeholder]="'Search'" [displayMember]="'DeptDesc'" [array]="Plants"
                  (filteredReturn)="filteredModules = $event">
                </mat-select-filter>
                <mat-option *ngFor="let plant of filteredModule" [value]="plant.DeptId">
                  {{plant.DeptDesc}}
                </mat-option>
            </mat-select>
          </mat-form-field>
          <button (click)="openModal()" *ngIf="IsWrite" class="icon-btn" pTooltip="Add WhatAppConfig" tooltipPosition="top">
            <img src="assets/images/add.png" alt="" width="20px" height="20px">
          </button>
        </div>
        <div style="margin-top: 14px"> 
          <mat-card-content>
            <ag-grid-angular  style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="whatAppConfigList"
              [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [frameworkComponents]="frameworkComponents"
              [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10">
            </ag-grid-angular>
          </mat-card-content>
        </div>  
      </div>
    </form>
  
    <ng-template #displayRoleModal>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2 *ngIf="whatAppConfigMode">{{langObj ? langObj?.AddWhatAppConfig : ('AddWhatAppConfig' | translate)}}</h2>
          <h2 *ngIf="!whatAppConfigMode">{{langObj ? langObj?.UpdateWhatAppConfig : ('UpdateWhatAppConfig' | translate)}}</h2>
          <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <form [formGroup]="addWhatAppConfigForm">
        <mat-dialog-content>
          <div class="wrapper-box wrapper-box-shadow table-wrapper">
            <div class="content-top-row"> 
              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="margin-left: 14px; width:400px">
                <mat-label>{{langObj ? langObj?.AccountSid : ('AccountSid' | translate)}}</mat-label>
                <input matInput name="Shift Desc" formControlName="accountSid" />
              </mat-form-field>
              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="margin-left: 14px; width:400px">
                <mat-label>{{langObj ? langObj?.AuthToken : ('AuthToken' | translate)}}</mat-label>
                <input matInput name="AuthToken" formControlName="authToken" />
              </mat-form-field>
              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="margin-left: 14px; width:400px">
                <mat-label>{{langObj ? langObj?.FromNumber : ('FromNumber' | translate)}}</mat-label>
                <input matInput name="From Number" formControlName="fromNumber" />
              </mat-form-field>  
            </div>
          </div>  
            <div class="content-top-row d-flex justify-content-center align-items-center">
              <section class="example-section" style="margin-left: 28px;">
                <mat-checkbox class="example-margin" formControlName="isActive">{{langObj ? langObj?.IsActive : ('IsActive' | translate)}}</mat-checkbox>
              </section>
              <div class="d-flex justify-content-between align-items-center" style="margin-left: 18px">
              <button type="submit" class="icon-btn" style="margin-left: 10px;" matTooltip="Update"
                matTooltipClass="custom-tooltip" matTooltipPosition="above" *ngIf="!whatAppConfigMode"
                (click)="UpdateWhatAppConfig()">
                <img src="assets/images/edit.png" alt="" width="20px" height="20px">
              </button>
              <button type="submit" class="icon-btn" style="margin-left: 10px;" matTooltip="Save"
                matTooltipClass="custom-tooltip" matTooltipPosition="above" *ngIf="whatAppConfigMode"
                (click)="SubmitWhatAppConfig()">
                <img src="assets/images/save.png" alt="" width="20px" height="20px">
              </button>
            </div>
          </div>
        </mat-dialog-content>
      </form>
    </ng-template>
    <ng-template #displayChildModal>
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{langObj ? langObj?.WhatAppInfo : ('WhatAppInfo' | translate)}}</h2>
          <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <div class="content-row-flex-both-end">
        <table mat-table class="basic-table plant-model-table" matSort [dataSource]="whatAppInfoDataSource">

          <ng-container matColumnDef="ToNumber">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header
              class="header-min-width">
              <p class="header-text">{{langObj ? langObj?.ToNumber : ('ToNumber' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.toNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="MsgContent">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header
              class="header-min-width">
              <p class="header-text">{{langObj ? langObj?.MsgContent : ('MsgContent' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.msgContent }}</td>
          </ng-container>
          <ng-container matColumnDef="IsProcessed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.IsProcessed : ('IsProcessed' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.isProcessed }}</td>
          </ng-container>
          <ng-container matColumnDef="ResponseSid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.ResponseSid : ('ResponseSid' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.responseSid }}</td>
          </ng-container>
          <ng-container matColumnDef="StatusMsg">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.StatusMsg : ('StatusMsg' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.statusMsg }}</td>
          </ng-container>
          <ng-container matColumnDef="ProcessedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.ProcessedOn : ('ProcessedOn' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.processedOn }}</td>
          </ng-container>
          <ng-container matColumnDef="CreatedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.CreatedOn : ('CreatedOn' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.createdOn | date: 'medium' }}</td>
          </ng-container>

          <ng-container matColumnDef="CreatedBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.createdBy }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="whatAppInfoColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: whatAppInfoColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="10">{{langObj ? langObj?.NodataFound : ('NodataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
      <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
    </ng-template>
  </div>
  
